import { TRAINING_STEP } from '../types';
const getStatus = status => {
  const trainingStep = {
    isTraining: status === TRAINING_STEP.TRAINING_IN_PROGRESS,
    isTrainingError: status === TRAINING_STEP.TRAINING_ERROR,
    isTrained: status === TRAINING_STEP.TRAINING_FINISHED,
    isGenerating: status === TRAINING_STEP.KEYWORD_GENERATION,
    isFetching: status === TRAINING_STEP.KEYWORD_FETCHING,
    isLoaded: status === TRAINING_STEP.KEYWORDS_LOADED,
    isViewing: status === TRAINING_STEP.KEYWORDS_VIEWING,
    isDisabled: false,
    isTagging: false,
    isExtracting: false
  };
  trainingStep.isDisabled = trainingStep.isGenerating || trainingStep.isTraining || trainingStep.isFetching;
  trainingStep.isTagging = trainingStep.isTraining || trainingStep.isTrained || trainingStep.isTrainingError;
  trainingStep.isExtracting = trainingStep.isGenerating || trainingStep.isFetching;
  return trainingStep;
};
export default getStatus;